import React from 'react';
import classNames from 'classnames';
import { useTranslation } from 'hooks';
import Form from 'components/ui/form';
import Button from 'components/ui/button';
import Input from 'components/ui/input';
import InputPassword from 'components/ui/inputPassword';
import { Link } from 'react-router-dom';

interface Props {
  email: string;
  signUpLink: string;
  password: string;
  isLoading: boolean;
  validation: any;
  isInternalSignup?: boolean
  onChange: (key: string, value: string) => void;
  onLogin: () => void;
  goToResetPassword: () => void;
}

const LoginFormLegacy: React.FC<Props> = ({
  email,
  password,
  isLoading,
  validation,
  signUpLink,
  onChange,
  goToResetPassword,
  onLogin,
  isInternalSignup
}) => {
  const getTranslate = useTranslation();

  return (
    <div className='auth-form'>
      <Form onSubmit={onLogin}>
        <div className='auth-form__fields'>
          <div className='auth-form__row'>
            <Input
              disabled={isLoading}
              id='email'
              label={getTranslate('auth.email.label')}
              placeholder={getTranslate('auth.email.placeholder')}
              value={email}
              onChange={(event) => onChange('email', event.target.value)}
              modern
            />
          </div>

          <div className='auth-form__row'>
            <InputPassword
              disabled={isLoading}
              id='password'
              value={password}
              label={getTranslate('auth.password.label')}
              placeholder={getTranslate('auth.password.placeholder')}
              customClass={classNames({ 'ui-input_empty': !password })}
              onChange={(event) => onChange('password', event.target.value)}
              modern
            />
          </div>

          {validation && (validation.email || validation.password) ? (
            <div className='auth-form__error'>
              {validation.email ? (
                <p className='auth-form__error-text'>
                  {getTranslate(validation.email)}
                </p>
              ) : null}
              {validation.password ? (
                <p className='auth-form__error-text'>
                  {getTranslate(validation.password)}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
        <Button
          loading={isLoading}
          text={getTranslate('auth.login.button')}
          status='primary'
          type='submit'
          size='large'
          customClass='page-auth__btn ui-button_full-width'
        />

        {signUpLink ? (
          <div className='page-auth__link'>
            {
              isInternalSignup ?
                <Link to={signUpLink} className='utils-link'>
                  {getTranslate('auth.signUp.link')}
                </Link>
                :
                <a
                  href={signUpLink}
                  target='_blank'
                  rel='noreferrer noopener'
                  className='utils-link'>
                  {getTranslate('auth.signUp.link')}
                </a>
            }

          </div>
        ) : null}
        <div className='page-auth__link'>
          <span onClick={goToResetPassword} className='utils-link'>
            {getTranslate('auth.forgotPassword.link')}
          </span>
        </div>
      </Form>
    </div>
  );
};

export { LoginFormLegacy };